<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      classeOpcoes(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      },
      valorTotal(item) {
        const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
        const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);
        const desconto = this.$options.filters.formatarNumero(item.desconto, true);
        const vat = this.$options.filters.formatarNumero(item.vat, true);

        return (((quantidade * valorEstimado) - desconto) * (1 + (vat / 100)));
      },
    }
  }
</script>

<template>
  <div>
    <h3 class="m-t m-b">Elemento de Despesa</h3>
    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.despesaCapital)"></i> Despesa de Capital <br>
        </dt>
      </dl>

      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.materialConsumo)"></i> Material de Consumo <br>
        </dt>
      </dl>

      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.servico)"></i> Serviço <br>
        </dt>
      </dl>
    </div>

    <div class="hr-line-dashed"></div>

    <dl>
      <dt>Descrição do material/serviço</dt>
      <dd class="white-space-pre">{{ item.descricao }}</dd>
    </dl>

    <div class="row">
      <dl class="col-sm-2">
        <dt>Código do item</dt>
        <dd class="white-space-pre">{{ item.codigoItem || '---'  }}</dd>
      </dl>

      <dl :class="{'col-xs-2': configuracao.utilizarValorEstimadoImportacao, 'col-xs-4': !configuracao.utilizarValorEstimadoImportacao}">
        <dt>Quantidade</dt>
        <dd>{{ item.quantidade | fixar2digitos }}</dd>
      </dl>

      <dl class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
        <dt>Valor unitário</dt>
        <dd>{{ item.valorEstimado | fixar2digitos }}</dd>
      </dl>

      <dl class="col-xs-2">
        <dt>Desconto total</dt>
        <dd>{{ item.desconto | fixar2digitos }}</dd>
      </dl>

      <dl class="col-xs-2">
        <dt>VAT %</dt>
        <dd>{{ item.vat | fixar2digitos }}</dd>
      </dl>

      <dl class="col-xs-2">
        <dt>Valor total</dt>
        <dd>{{ valorTotal(item) | formatarNumero }}</dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-sm-2">
        <dt>Unidade</dt>
        <dd>{{ item.unidade || '---' }}</dd>
      </dl>

      <dl class="col-sm-2">
        <dt>NCM ou HS CODE</dt>
        <dd>{{ item.ncmhsCode || '---' }}</dd>
      </dl>

      <dl class="col-sm-4">
        <dt>Nome fabricante</dt>
        <dd>{{ item.nomeFabricante || '---' }}</dd>
      </dl>

      <dl class="col-sm-4">
        <dt>País procedência</dt>
        <dd>{{ item.paisProcedencia || '---' }}</dd>
      </dl>
    </div>

    <div class="hr-line-dashed"></div>

    <dl>
      <dt>Observação do item de importação</dt>
      <dd class="white-space-pre">{{ item.observacaoItemImportacao || '---' }}</dd>
    </dl>

    <dl>
      <dt>Objetivo/Justificativa da importação</dt>
      <dd class="white-space-pre">{{ item.objetivoImportacao || '---' }}</dd>
    </dl>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao/componentes/compartilhado/FormListaImportacao.vue